import { gql } from 'urql';

const GetAgreements = gql`
  query GetAgreements($types: [ApplicationProductTypeEnum]!) {
    agreements(types: $types) {
      id
      type
      title
      resource {
        htmlId
        pdfId
        textId
        htmlDocument {
          id
          url
        }
        pdfDocument {
          id
          url
        }
        textDocumentHtml
      }
    }
  }
`;

export default GetAgreements;
